<template>
  <div
    class="column q-mx-auto"
    style="width: 100%; max-width: 800px"
  >
    <slot name="header" />
    <activity-sales-category-page
      :activity-booking="activityBooking"
    />
  </div>
</template>

<script>
import ActivityBooking from 'src/models/activity/ActivityBooking'
import ActivitySalesCategoryPage from 'src/modules/checkout/components/ActivitySalesCategoryPage.vue'
import { watchEffect } from 'vue'

export default {
  name: 'ActivitySelectAddOns',
  components: {
    ActivitySalesCategoryPage
  },
  inject: ['order', 'checkoutData'],
  props: {
    activityBooking: {
      type: ActivityBooking,
      required: true
    }
  },
  configuration: ['currentSite', 'activitySpaces'],
  data () {
    return {
      loading: false
    }
  },
  async mounted () {
    if (_.isNil(this.checkoutData)) return

    this.stopWatch = watchEffect(() => {
      this.checkoutData.showLoading = this.loading
      this.checkoutData.purchasingMembership = false

      this.checkoutData.stepTitle = this.$i18n.t('checkout.steps.addOns')
      this.checkoutData.showActivityCard = true
      this.checkoutData.showCartControls = true
      this.checkoutData.showCheckoutFooter = true

      this.checkoutData.expandDefault = false
      this.checkoutData.expandActivityItems = true
      this.checkoutData.expandConcessions = false
      this.checkoutData.expandTickets = false
      this.checkoutData.expandActivityTickets = false

      this.checkoutData.infoTitle = this.$i18n.t('checkout.infoTitles.addOns')
      this.checkoutData.info = this.$i18n.tc('item.itemCount', this.activityBooking.activitySalesItemOrderItems.length)
      this.checkoutData.showInfo = true
      this.checkoutData.showSubtotal = true
      this.checkoutData.showTotals = false

      this.checkoutData.showEmptyCartNextLabel = true

      this.checkoutData.canProceed = true
    })
  },
  unmounted () {
    this.stopWatch?.()
  }
}
</script>
